import PageHeaderBlock, { PageHeaderBlockProps } from './PageHeaderBlock';

export type { PageHeaderBlockProps };
export default PageHeaderBlock;
